import '../src/styles/entry-page.sass';
import ReactOnRails from 'react-on-rails';

import EntryPage from '../bundles/EntryPage';
import ErrorPage from "../bundles/ErrorPage";

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({ EntryPage, ErrorPage, });
